import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
import anatomy from './images/anatomy.png';
import doPosition from './images/do-position.png';
import doReturnLinks from './images/do-use-return-urls.png';
import dontReturnLinks from './images/dont-use-return-urls.png';
import doUseDisclaimer from './images/do-use-disclaimer.png';
import dontUseDisclaimer from './images/dont-use-disclaimer.png';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2>{`Anatomy`}</h2>
    <img src={anatomy} alt="Footnotes as an ordered list of citations, with visual indicators marking items and return urls" />
    <h2>{`Usage`}</h2>
    <h3>{`Position`}</h3>
    <p>{`Footnotes should generally appear at the bottom of the page.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doPosition} alt="" />
    <Caption mdxType="Caption">Place footnotes towards the end of a page.</Caption>
  </Do>
    </DoDontContainer>
    <h3>{`Return links`}</h3>
    <p>{`Citations in the format of a numbered list should feature both a local description and a link to return the user to the original context.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doReturnLinks} alt="" />
    <Caption mdxType="Caption">
      Include sufficient descriptions for each citation, alongside a return
      link.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src={dontReturnLinks} alt="" />
    <Caption mdxType="Caption">
      Don't require users to manually locate the original context for each
      citation.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Paragraphs`}</h3>
    <p>{`Use paragraphs to present disclaimers or similar types of content.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doUseDisclaimer} />
    <Caption mdxType="Caption">Use paragraphs for context-agnostic items of text.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontUseDisclaimer} />
    <Caption mdxType="Caption">
      Don't use paragraphs to represent citations or numbered lists.
    </Caption>
  </Dont>
    </DoDontContainer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      